import httpMethod from 'services/update2025/httpMethod';
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ForeignerPersonalContext } from "./ForeignerPersonalContext";

export const ForeignerPersonalEditor = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["foreigner-personal", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const foreignerPersonalContext = useContext(ForeignerPersonalContext);
    const { foreignerPersonals, setForeignerPersonals, foreignerPersonal, setForeignerPersonal, foreignerPersonalDialog, setForeignerPersonalDialog } = foreignerPersonalContext;

    const hideDialog = () => {
        setForeignerPersonalDialog(false);
    };

    return (
        <Dialog visible={foreignerPersonalDialog} style={{ width: "70%" }} header={t("foreigner-personal.titleDetailEditor")} modal className="p-fluid text-center" onHide={hideDialog}>
            <div className="formgrid">
                <div className="grid text-left">
                    <div className="col-12">
                        <div className="grid">
                            {/* Họ và tên */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="fullName">{t("foreigner-personal.fullName")}</label>
                                <InputText id="fullName" value={foreignerPersonal?.fullName} readOnly className="custom-form" />
                            </div>

                            {/* ngày sinh */}
                            <div className="field col-12 md:col-2">
                                <label htmlFor="birthDate">{t("foreigner-personal.birthDate")}</label>
                                <InputText id="birthDate" value={foreignerPersonal?.birthDate} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="gender">{t("foreigner-personal.gender")}</label>
                                <InputText id="gender" value={foreignerPersonal?.gender} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="phoneNumber">{t("foreigner-personal.phoneNumber")}</label>
                                <InputText id="phoneNumber" value={foreignerPersonal?.phoneNumber} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="accLevel">{t("foreigner-personal.accLevel")}</label>
                                <InputText id="accLevel" value={foreignerPersonal?.accLevel} readOnly className="custom-form" />
                            </div>
                        </div>

                        <div className="grid">
                            {/* Họ và tên */}
                            <div className="field col-12 md:col-2">
                                <label htmlFor="idNumber">{t("foreigner-personal.idNumber")}</label>
                                <InputText id="idNumber" value={foreignerPersonal?.idNumber} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="passport">{t("foreigner-personal.passport")}</label>
                                <InputText id="passport" value={foreignerPersonal?.passport} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="email">{t("foreigner-personal.email")}</label>
                                <InputText id="email" value={foreignerPersonal?.email} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="nationality">{t("foreigner-personal.nationality")}</label>
                                <InputText id="nationality" value={foreignerPersonal?.nationality} readOnly className="custom-form" />
                            </div>
                        </div>

                        <div className="grid">
                            {/* Họ và tên */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="address">{t("foreigner-personal.address")}</label>
                                <InputText id="address" value={foreignerPersonal?.address} readOnly className="custom-form" tooltip={foreignerPersonal?.address} tooltipOptions={{ position: "top" }} />
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="curAddress">{t("foreigner-personal.curAddress")}</label>
                                <InputText id="curAddress" value={foreignerPersonal?.curAddress} readOnly className="custom-form" tooltip={foreignerPersonal?.curAddress} tooltipOptions={{ position: "top" }} />
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="temporaryAddress">{t("foreigner-personal.temporaryAddress")}</label>
                                <InputText id="temporaryAddress" value={foreignerPersonal?.temporaryAddress} readOnly className="custom-form" tooltip={foreignerPersonal?.temporaryAddress} tooltipOptions={{ position: "top" }} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid">
                    <div className="col-12">
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
